const getCategoryFormattedName = name => {
  const nameWithoutAccents = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return nameWithoutAccents.replace(/\s/g, '-').replace('/', '_').toLowerCase();
};

export const CategoryHelper = {
  getCategoryFormattedName
};